import { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import { GoldenDustImg, QuestMarkImg } from "@/assets"
import styles from "./QuestsHero.module.scss"

export const QuestsHero: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.QuestsHero}>
      <QuestMarkImg />
      <div className={styles.QuestsHero_inner}>
        <h2 className={styles.QuestsHero_title}>{t("quests.header.title")}</h2>
        <p className={styles.QuestsHero_subtitle}>
          <Trans
            i18nKey="quests.header.subtitle"
            components={{
              hl: <span className={styles.QuestsHero_subtitle_highlight} />,
              gd: (
                <img
                  src={GoldenDustImg}
                  alt=""
                  aria-hidden
                  className={styles.QuestsHero_subtitle_icon}
                />
              ),
              reward: <span className={styles.QuestsHero_subtitle_reward} />
            }}
          />
        </p>
      </div>
    </div>
  )
}
